import { createAction, props } from '@ngrx/store';
import { Account } from '@wtax/data-angular';

export const enter = createAction('[Account Selection] enter');

export const loadAccounts = createAction('[Account Selection] loadAccounts');
export const loadAccountsSuccess = createAction('[Account Selection] loadAccountsSuccess', props<{ accounts: Account[] }>());
export const loadAccountsError = createAction('[Account Setup] loadAccountsError', props<{ error: string }>());
